import type { RootState } from '../store'

export const userData = (state: RootState) => state.user.userData

export const referralCodeSelector = (state: RootState) =>
  state.user.userData.referralCode?.id

export const paymentWalletSelector = (state: RootState) =>
  state.user.paymentWallet
